import RestaurantScheme from './RestaurantScheme';

export default RestaurantScheme;
